import React from 'react'
import {
  ArrowLeft,
  ChevronRight,
  Network
} from "lucide-react";
import "./IndicatorInfoPanel.css"

const IndicatorInfoPanel = ({
    sources,
    navigationStack,
    selectedIndicator,
    onNavigateBack,
    onNavigateToChildren
  }) => {

  const normalizeSources = (sources) => {
    if (!sources) return []

    // already array
    if (Array.isArray(sources)) return sources

    // try parsing JSON string
    try {
      const parsed = JSON.parse(sources)
      if (Array.isArray(parsed)) return parsed
    } catch (e) {
      // ignore
    }

    // fallback: treat as single string
    return [sources]
  }

  return (
    <div className="indicator-info-panel">

      {navigationStack?.length > 0 && (
        <>
          <p><strong>Navigation</strong></p>

          <div className="indicator-info-nav-trail">
            {navigationStack.map(item => item.name).join(' > ')}
          </div>

          <hr />
        </>
      )}

      <div className="indicator-info-toolbar">
        {navigationStack?.length > 0 && (
          <button
            className="btn btn-sm btn-outline-secondary"
            onClick={onNavigateBack}
          >
            <ArrowLeft size={14} />
          </button>
        )}

        {selectedIndicator?.related_ids?.length > 0 && (
          <button
            className="btn btn-sm btn-outline-primary indicator-info-related-btn"
            onClick={onNavigateToChildren}
          >
            <Network size={14} />
            Related ({selectedIndicator.related_ids.length})
          </button>
        )}
      </div>

      <p><strong>Sources</strong></p>

      {sources ? (
        <div
          dangerouslySetInnerHTML={{
            __html: normalizeSources(sources).join(', ')
          }}
        />
      ) : (
        <p>No sources available</p>
      )}
    </div>
  )
}

export default IndicatorInfoPanel
